import type { QueryClient } from '@tanstack/react-query';

/** Clear only the new card projection when the authenticated identity changes. */
export function clearPersonalMemberCardCache(client: QueryClient): void {
  const filters = { queryKey: ['merchantmembers', 'getPersonalMemberCard'] };
  void client.cancelQueries(filters);
  client.removeQueries(filters);
}
